import React, { useState } from "react";
import { View, StyleSheet } from "react-native";
import Text from "./text";
import translate from "libs/locale";

const Prices = ({
  total = 0,
  delivery = 0,
  gst = 0,
  net = 0,
  serviceCharge = 0,
  gstService = -1,
  gstItems = -1,
  gstDelivery = -1,
}) => {
  return (
    <View>
      <View style={styles.dotted} />
      <View style={styles.item}>
        <Text style={[styles.itemName]}>{translate("subTotal")}</Text>
        <Text style={[styles.itemName, styles.price]}>{`${total?.toFixed(
          2
        )} INR`}</Text>
      </View>
      {gstItems >= 0 && (
        <View style={styles.item}>
          <Text style={[styles.itemName]}>{translate("gstItems")}</Text>
          <Text style={[styles.itemName, styles.price]}>{`${gstItems?.toFixed(
            2
          )} INR`}</Text>
        </View>
      )}
      {delivery !== null && (
        <View style={styles.item}>
          <Text style={[styles.itemName]}>{translate("deliveryFee")}</Text>
          <Text style={[styles.itemName, styles.price]}>{`${delivery?.toFixed(
            2
          )} INR`}</Text>
        </View>
      )}
      {gstDelivery !== null && gstDelivery >= 0 && (
        <View style={styles.item}>
          <Text style={[styles.itemName]}>{translate("gstDelivery")}</Text>
          <Text
            style={[styles.itemName, styles.price]}
          >{`${gstDelivery?.toFixed(2)} INR`}</Text>
        </View>
      )}
      {serviceCharge !== null && (
        <View style={styles.item}>
          <Text style={[styles.itemName]}>{translate("serviceCharge")}</Text>
          <Text
            style={[styles.itemName, styles.price]}
          >{`${serviceCharge?.toFixed(2)} INR`}</Text>
        </View>
      )}
      {gstService !== null && gstService >= 0 && (
        <View style={styles.item}>
          <Text style={[styles.itemName]}>{translate("gstService")}</Text>
          <Text style={[styles.itemName, styles.price]}>{`${gstService?.toFixed(
            2
          )} INR`}</Text>
        </View>
      )}
      {gstService === -1 && gstItems === -1 && (
        <View style={styles.item}>
          <Text style={[styles.itemName]}>{translate("totalGst")}</Text>
          <Text style={[styles.itemName, styles.price]}>{`${gst?.toFixed(
            2
          )} INR`}</Text>
        </View>
      )}
      <View style={[styles.dotted, styles.lastDotted]} />
      <View style={styles.item}>
        <Text style={[styles.itemName]}>{translate("netTotal")}</Text>
        <Text style={[styles.itemName, styles.price]}>{`${net?.toFixed(
          2
        )} INR`}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  dotted: {
    borderStyle: "dashed",
    borderWidth: 0.2,
    borderRadius: 0,
    marginTop: 30,
    borderColor: "#636E72",
  },
  itemName: {
    marginTop: 7,
    color: "#636E72",
    fontSize: 12,
  },
  item: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  lastDotted: {
    marginTop: 10,
  },
  price: {
    fontFamily: "MontserratBold",
  },
});

export default Prices;
